// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPerPersonSpendLimitPropertyDto
 */
export interface IPerPersonSpendLimitPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IPerPersonSpendLimitPropertyDto
     */
    per_person_spend_limit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPerPersonSpendLimitPropertyDto
     */
    per_person_spend_limit_state?: IPerPersonSpendLimitPropertyDtoPerPersonSpendLimitStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPerPersonSpendLimitPropertyDtoPerPersonSpendLimitStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPerPersonSpendLimitPropertyDto interface.
 */
export function instanceOfIPerPersonSpendLimitPropertyDto(value: object): value is IPerPersonSpendLimitPropertyDto {
    return true;
}

export function IPerPersonSpendLimitPropertyDtoFromJSON(json: any): IPerPersonSpendLimitPropertyDto {
    return IPerPersonSpendLimitPropertyDtoFromJSONTyped(json, false);
}

export function IPerPersonSpendLimitPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPerPersonSpendLimitPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'per_person_spend_limit': json['per_person_spend_limit'] == null ? undefined : json['per_person_spend_limit'],
        'per_person_spend_limit_state': json['per_person_spend_limit_state'] == null ? undefined : json['per_person_spend_limit_state'],
    };
}

export function IPerPersonSpendLimitPropertyDtoToJSON(json: any): IPerPersonSpendLimitPropertyDto {
    return IPerPersonSpendLimitPropertyDtoToJSONTyped(json, false);
}

export function IPerPersonSpendLimitPropertyDtoToJSONTyped(value?: IPerPersonSpendLimitPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'per_person_spend_limit': value['per_person_spend_limit'],
        'per_person_spend_limit_state': value['per_person_spend_limit_state'],
    };
}

